import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {
    excelPluginUsageReportsStateActions,
    excelPluginUsageReportsStateSelector,
} from './slices/excel-plugin-usage-reports-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const GeneratedExcelPluginUsageReportsPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(excelPluginUsageReportsStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(excelPluginUsageReportsStateActions.setPageSize(pageSize));
        dispatch(excelPluginUsageReportsStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(excelPluginUsageReportsStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={[5, 10]}
        />
    );
};
